module.exports = __webpack_public_path__ + "front/img/b25.503fd583.jpg";